import { Tooltip } from 'react-tooltip';
import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const TooltipTrigger = styled.span<{ $isPointer?: boolean }>`
    cursor: ${({ $isPointer }) => ($isPointer ? 'pointer' : 'inherit')};
    text-decoration: none;
`;

type TooltipProps = {
    $contentWidth?: string;
    $inverted?: boolean;
};

export const TooltipContentWrapper = styled.div`
    display: contents;
`;

export const TooltipContent = styled(Tooltip)<TooltipProps>`
    z-index: 9999;
    background-color: ${({ $inverted }) =>
        $inverted ? getPurpurColor('backgroundToneOnTonePrimary') : getPurpurColor('functionalWhite')};
    color: ${getPurpurColor('functionalBlack')};
    border-radius: ${getPurpurSpacing('100')};
    font-size: 0.875rem;
    font-weight: normal;
    line-height: 1.5;
    white-space: normal;
    outline: 0;
    transition-property: transform, visibility, opacity;
    box-shadow: 0 ${getPurpurSpacing('100')} ${getPurpurSpacing('200')} 0 rgba(34, 34, 34, 0.24);
    padding: ${getPurpurSpacing('250')};
    max-width: 25rem;
    width: ${({ $contentWidth }) => ($contentWidth ? $contentWidth : 'auto')};
    text-align: left;

    .react-tooltip-arrow {
        transform: rotate(45deg);
        width: 0.5rem;
        height: 0.5rem;
    }
`;
